module.exports = __webpack_public_path__ + "img/noble-level2-bg.3d2b4b44.png";